import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeUri',
  standalone: true
})
export class DecodeUriPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    try {
      return decodeURIComponent(value);
    } catch (e) {
      // If decoding fails (e.g., malformed URI), return original value
      return value;
    }
  }
}
